import { BigBoldText } from "../../../dashboard/home/home.style";
import { Container } from "../../../Users/components/logIncident/logIncident.style";
import "react-datepicker/dist/react-datepicker.css";
import GeneralForm from "../../../../../components/Forms/generalForm/GeneralForm";

interface IncidentParameterFormProps {
  title: string;
  handleCloseModal: () => void;
  handleSubmit: () => void;
}

const IncidentParameterForm = ({
  title,
  handleCloseModal,
  handleSubmit: handleFormSubmit,
}: IncidentParameterFormProps) => {
  return (
    <Container style={{ minHeight: "auto" }}>
      <div className="mb-7">
        <button
          type="button"
          onClick={handleCloseModal}
          className="cursor-pointer text-4xl font-medium"
          style={{ backgroundColor: "transparent", border: "0" }}
        >
          &times;
        </button>
        <div className="flex-1 text-center">
          <BigBoldText>{title}</BigBoldText>
        </div>
      </div>
      <GeneralForm
        closeFn={handleCloseModal}
        submitFn={handleFormSubmit}
        bottom={false}
      />
    </Container>
  );
};

export default IncidentParameterForm;
